import {
  DensityUnitSelectField,
  DimensionUnitSelectField,
  PackedOnSelectField,
  RangeField,
  StorageTypeSelectField,
  StrappingSelectField,
  TextField,
  useFormContext,
  useWatch,
} from 'form';
import { Stack, Typography } from 'ui';

import { PackagingSpecificationType } from '../../pages/schema';

export const PackagingSpecificationForm = () => {
  const form = useFormContext<PackagingSpecificationType>();
  const [dimensionUnit, densityUnit] = useWatch({
    control: form.control,
    name: ['dimension_unit', 'density_unit'],
  });
  return (
    <Stack spacing={2}>
      <TextField label="Alias" name="title" placeholder="Name..." />
      <StorageTypeSelectField name="storage_type" label="Storage type" required />
      <PackedOnSelectField name="packed_on" label="Packed on" />
      <StrappingSelectField name="strapping" label="Strapping" multiple />

      <Typography variant="body1" fontWeight="bold">
        Weight
      </Typography>
      <RangeField minName="min_weight" maxName="max_weight" label="Unit weight" endAdornment="kg" />
      <RangeField minName="min_load_weight" maxName="max_load_weight" label="Load weight" endAdornment="MT" />

      <Typography variant="body1" fontWeight="bold">
        Dimensions
      </Typography>
      <DimensionUnitSelectField name="dimension_unit" label="Unit of measurement" />
      <RangeField minName="min_width" maxName="max_width" label="Width" endAdornment={dimensionUnit} />
      <RangeField minName="min_height" maxName="max_height" label="Height" endAdornment={dimensionUnit} />
      <RangeField minName="min_length" maxName="max_length" label="Length" endAdornment={dimensionUnit} />

      <Typography variant="body1" fontWeight="bold">
        Density
      </Typography>
      <DensityUnitSelectField name="density_unit" label="Density" />
      <RangeField minName="min_density" maxName="max_density" label="Density" endAdornment={densityUnit} />
    </Stack>
  );
};
